/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarrierLookupDeliveryNoteKeysRequest } from '../../models/carrier-lookup-delivery-note-keys-request';
import { CarrierLookupDeliveryNoteResponse } from '../../models/carrier-lookup-delivery-note-response';
import { KeyType } from '../../models/key-type';

export interface LookupDeliveryNoteKeys$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: CarrierLookupDeliveryNoteKeysRequest
}

export function lookupDeliveryNoteKeys(http: HttpClient, rootUrl: string, params: LookupDeliveryNoteKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierLookupDeliveryNoteResponse>> {
  const rb = new RequestBuilder(rootUrl, lookupDeliveryNoteKeys.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CarrierLookupDeliveryNoteResponse>;
    })
  );
}

lookupDeliveryNoteKeys.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/lookup';
